import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import { ToastProvider } from "./components/ux/Toast";
import { ConfirmProvider } from "./components/ConfirmModal";
import { EventStateProvider } from "./lib/eventState";
import { InterestedCelebrationProvider } from "./lib/interestedCelebration";
import "./styles/index.css";
import { AuthProvider, PlatformProvider } from "./lib/platform";
import { TrackingInitializer } from "./lib/tracking";
import { PostHogProvider } from "posthog-js/react";
import { forceParameterFeatureFlags } from "./lib/features";
import { TranslationProvider } from "./lib/i18n/TranslationProvider";
import { LanguageSyncInitializer } from "./lib/i18n/LanguageSyncInitializer";
import { PostHogConfig } from "posthog-js";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const postHogOptions: Partial<PostHogConfig> = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: "2025-11-30",
  autocapture: true,
  person_profiles: 'identified_only',
  loaded: forceParameterFeatureFlags,
};

ReactDOM.createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
  <TranslationProvider>
    <ToastProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <PostHogProvider
            apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
            options={postHogOptions}
          >
            <PlatformProvider>
              <TrackingInitializer>
                <LanguageSyncInitializer>
                  <ConfirmProvider>
                    <EventStateProvider>
                      <InterestedCelebrationProvider>
                        <App />
                      </InterestedCelebrationProvider>
                    </EventStateProvider>
                  </ConfirmProvider>
                </LanguageSyncInitializer>
              </TrackingInitializer>
            </PlatformProvider>
          </PostHogProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ToastProvider>
  </TranslationProvider>
  </ErrorBoundary>,
);
